import { ACTIONS } from '../../actions/registry.js';

export default function ActionsList({ onSelect }) {
    return (
        <div className="flex flex-col gap-1.5 px-2">
            {ACTIONS.map((action) => (
                <ActionCard
                    key={action.id}
                    action={action}
                    onClick={() => onSelect(action.id)}
                />
            ))}
        </div>
    );
}

function ActionCard({ action, onClick }) {
    const Icon = action.icon;
    return (
        <button
            onClick={onClick}
            className="group flex items-start gap-2.5 rounded-md px-2.5 py-2
                       bg-bg border border-slate-800 hover:border-accent-action/50
                       hover:bg-accent-action/5 transition text-left"
        >
            <span className="mt-0.5 text-accent-action shrink-0">
                <Icon size={13} />
            </span>
            <div className="min-w-0 flex-1">
                <div className="text-xs font-medium text-slate-200 group-hover:text-accent-info truncate">
                    {action.name}
                </div>
                <div className="text-[10px] text-fg-secondary leading-relaxed mt-0.5">
                    {action.description}
                </div>
            </div>
        </button>
    );
}